<!-- eslint-disable no-unused-vars -->
<script setup>
import { ref, onMounted } from "vue";
import DataService from '../../services/data.service';
import EventBus from "../../common/EventBus";
import DataTable from "datatables.net-vue3";
import DataTableLib from "datatables.net-bs5";
import ButtonHtml5 from "datatables.net-buttons/js/buttons.html5";
import print from "datatables.net-buttons/js/buttons.print";
import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ExcelJS from "exceljs";
import logoUnneUrl from "@/assets/img/logos/Logo unne.png";
import "datatables.net-responsive-bs5";
import * as bootstrap from 'bootstrap'; 
import JSZip from "jszip";
window.JSZip = JSZip;
pdfMake.vfs = pdfFonts.pdfMake.vfs;
DataTable.use(DataTableLib);
DataTable.use(pdfMake);
DataTable.use(ButtonHtml5);
DataTable.use(print);

const solicitudes = ref([]);
const fechaInicio = ref('');
const fechaFin = ref('');
const tableKey = ref(0);
const currentSearchValue = ref('');
const exportLoading = ref(false);

const columns = [
  { data: "documento_empleado" },
  { data: "nombre_empleado" },
  { data: "nombre_institucion" },
  {
    data: null,
    render: function (data, type, row, meta) {
      let estado = data.nombre_estado;
      let clase = "";
      switch (estado) {
        case "En proceso":
          clase = "badge badge-sm bg-gradient-secondary";
          break;
        case "Revision":
        case "Revisión":
        case "En revision":
        case "En revisión":
        case "En Revision":
        case "En Revisión":
          clase = "badge badge-sm bg-gradient-warning";
          break;
        case "Aceptado":
          clase = "badge badge-sm bg-gradient-success";
          break;
        case "Rechazado":
          clase = "badge badge-sm bg-gradient-danger";
          break;
      }
      return `<span class="${clase}">${estado}</span>`;
    },
  },
  {
    data: null,
    render: function (data, type, row, meta) {
      return `${formatDate(data.horario)}`;
    },
  },
  {
    data: null,
    render: function (data, type, row, meta) {
      if (!data.dias) {
        return "";
      }
      return `${formatDate(data.horario, (data.dias - 1) )}`;
    },
  },
  { data: "nombre_motivo" },
  { data: null,
    // eslint-disable-next-line no-unused-vars
    render: function (data, type, row, meta) {
      let estado = data.tipo_licencia_id;
      let text = "";
      switch (estado) {
        case 1:
          text = "Corto T.";
          break;
        case 2:
          text = "Largo T.";
          break;
      }
      return `<span>${text}</span>`;
    }, 
  },
  { data: "dias" },
  {
    data: null,
    render: function (data, type, row, meta) {
      if (data.nombre_estado === "En proceso") {
        return '';
      }
      return `<button class="btn btn-info btn-sm" onclick="window.showDetails('${encodeURIComponent(JSON.stringify(data))}')">
                <i class="fas fa-eye"></i> Ver Detalles
              </button>`;
    }
  }
];

const selectedSolicitud = ref(null);
window.showDetails = (data) => {
  selectedSolicitud.value = JSON.parse(decodeURIComponent(data));
  const myModal = new bootstrap.Modal(document.getElementById('detallesModal'));
  myModal.show();
};

const exportHeaders = ['DNI', 'Personal', 'Institución', 'Estado', 'Fecha Inicio', 'Fecha Fin', 'Motivo', 'Tipo Lic.', 'Cant. Días'];

function rowToExportRow(row) {
  const tipoLic = row.tipo_licencia_id === 1 ? 'Corto T.' : row.tipo_licencia_id === 2 ? 'Largo T.' : '';
  return [
    row.documento_empleado ?? '',
    row.nombre_empleado ?? '',
    row.nombre_institucion ?? '',
    row.nombre_estado ?? '',
    formatDate(row.horario),
    row.dias ? formatDate(row.horario, row.dias - 1) : '',
    row.nombre_motivo ?? '',
    tipoLic,
    row.dias ?? '',
  ];
}

function getExportParams() {
  return {
    start: 0,
    length: 10000,
    draw: 1,
    search: { value: currentSearchValue.value || '' },
    fecha_inicio: fechaInicio.value || undefined,
    fecha_fin: fechaFin.value || undefined,
    export: 1,
  };
}

function fetchAllForExport() {
  return DataService.getInasistenciaPaginated(getExportParams())
    .then((res) => res.data.data || []);
}

function downloadBlob(content, filename, mime) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function escapeCsvCell(str) {
  const s = String(str ?? '');
  if (/[",\n\r]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
  return s;
}

function getLogoBase64(url) {
  return fetch(url)
    .then((r) => r.blob())
    .then((blob) => new Promise((res, rej) => {
      const r = new FileReader();
      r.onload = () => res(r.result);
      r.onerror = rej;
      r.readAsDataURL(blob);
    }));
}

function exportExcel() {
  exportLoading.value = true;
  Promise.all([getLogoBase64(logoUnneUrl), fetchAllForExport()])
    .then(([logoDataUrl, data]) => {
      const base64 = logoDataUrl.replace(/^data:image\/\w+;base64,/, '');
      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet('Solicitudes', { views: [{ state: 'frozen', ySplit: 3 }] });
      const imageId = wb.addImage({ base64, extension: 'png' });
      ws.addImage(imageId, { tl: { col: 3, row: 0 }, ext: { width: 220, height: 90 } });
      ws.addRow([]);
      ws.addRow([]);
      ws.getRow(1).height = 70;
      ws.getRow(2).height = 12;
      ws.addRow(exportHeaders);
      data.forEach((row) => ws.addRow(rowToExportRow(row)));
      return wb.xlsx.writeBuffer();
    })
    .then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Reporte_Solicitudes.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    })
    .catch(() => {})
    .finally(() => { exportLoading.value = false; });
}

function exportPDF() {
  exportLoading.value = true;
  Promise.all([getLogoBase64(logoUnneUrl), fetchAllForExport()])
    .then(([logoDataUrl, data]) => {
      const body = data.map(rowToExportRow);
      const pdfHeaders = ['DNI', 'Personal', 'Institución', 'Estado', 'Fecha Inicio', 'Fecha Fin', 'Motivo', 'Tipo Lic.', 'Cant. Días'];
      const doc = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        content: [
          { image: logoDataUrl, width: 200, alignment: 'center', margin: [0, 0, 0, 12] },
          { text: 'Reporte de Solicitudes', style: 'header', margin: [0, 0, 0, 8] },
          {
            table: { headerRows: 1, widths: ['*', '*', '*', '*', '*', '*', '*', '*', 'auto'], body: [pdfHeaders, ...body] },
            layout: 'lightHorizontalLines',
          },
        ],
        styles: { header: { fontSize: 14, bold: true } },
      };
      pdfMake.createPdf(doc).download('Reporte_Solicitudes.pdf');
    })
    .catch(() => {})
    .finally(() => { exportLoading.value = false; });
}

function exportPrint() {
  exportLoading.value = true;
  const printHeaders = ['DNI', 'Personal', 'Institución', 'Estado', 'Fecha Inicio', 'Fecha Fin', 'Motivo', 'Tipo Lic.', 'Cant. Días'];
  fetchAllForExport()
    .then((data) => {
      const body = data.map(rowToExportRow);
      const thead = '<thead><tr>' + printHeaders.map((h) => '<th>' + String(h) + '</th>').join('') + '</tr></thead>';
      const tbody = '<tbody>' + body.map((r) => '<tr>' + r.map((c) => '<td>' + String(c) + '</td>').join('') + '</tr>').join('') + '</tbody>';
      const logoImg = '<div style="text-align:center;margin-bottom:16px;"><img src="' + logoUnneUrl + '" alt="UNNE" style="height:90px;display:inline-block;" /></div>';
      const win = window.open('', '_blank');
      win.document.write('<html><head><title>Reporte de Solicitudes</title><link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet"></head><body><div class="container p-4">' + logoImg + '<h5>Reporte de Solicitudes</h5><table class="table table-bordered table-sm">' + thead + tbody + '</table></div></body></html>');
      win.document.close();
      win.focus();
      setTimeout(() => { win.print(); win.close(); }, 250);
    })
    .catch(() => {})
    .finally(() => { exportLoading.value = false; });
}

function exportCSV() {
  exportLoading.value = true;
  fetchAllForExport()
    .then((data) => {
      const rows = [exportHeaders, ...data.map(rowToExportRow)];
      const csv = rows.map((r) => r.map(escapeCsvCell).join(',')).join('\r\n');
      const BOM = '\uFEFF';
      downloadBlob(BOM + csv, 'Reporte_Solicitudes.csv', 'text/csv;charset=utf-8');
    })
    .catch(() => {})
    .finally(() => { exportLoading.value = false; });
}

const button = [];

function ajaxDataTable(data, callback) {
  currentSearchValue.value = data.search?.value ?? '';
  const params = {
    ...data,
    fecha_inicio: fechaInicio.value || undefined,
    fecha_fin: fechaFin.value || undefined,
  };
  DataService.getInasistenciaPaginated(params)
    .then((res) => callback(res.data))
    .catch((error) => {
      if (error.response && error.response.status === 403) {
        EventBus.dispatch("logout");
      }
      callback({
        data: [],
        recordsTotal: 0,
        recordsFiltered: 0,
        draw: data.draw,
      });
    });
}

function reloadTable() {
  tableKey.value += 1;
}

function formatDate(date, daysToAdd = 0) {
  if (!date) return ""; // Manejar el caso cuando la fecha es undefined o null

  // Parsear la fecha en formato 'YYYY-MM-DD'
  const [year, month, day] = date.split("-");

  // Crear un nuevo objeto Date con la fecha parseada
  const originalDate = new Date(year, month - 1, day);

  // Sumar los días adicionales
  originalDate.setDate(originalDate.getDate() + daysToAdd);

  // Obtener los componentes de la fecha modificada
  const newYear = originalDate.getFullYear();
  const newMonth = originalDate.getMonth() + 1;
  const newDay = originalDate.getDate();

  // Formatear y retornar la nueva fecha
  return `${newDay}-${newMonth < 10 ? "0" : ""}${newMonth}-${newYear}`;
}
</script>
<style>
@import "datatables.net-bs5";

.dt-type-numeric {
  text-align: center !important;
}
.dt-paging {
  display: flex;
  float: right;
}

.dt-search{
  position: inherit !important;
}
</style>

<template>
  <div class="card">
    <div class="card-header pb-0 pl-0 d-flex justify-content-between align-items-center">
      <h6>Tabla de Solicitudes</h6>
      <div class="d-flex gap-3 align-items-center">
        <div>
          <label class="me-2">Fecha Inicio:</label>
          <input 
            type="date" 
            class="form-control form-control-sm" 
            v-model="fechaInicio"
            @change="reloadTable"
          >
        </div>
        <div>
          <label class="me-2">Fecha Fin:</label>
          <input 
            type="date" 
            class="form-control form-control-sm" 
            v-model="fechaFin"
            @change="reloadTable"
          >
        </div>
      </div>
    </div>
    <div class="card-body px-1 pt-0 pb-2">
      <div class="d-flex flex-wrap gap-2 align-items-center mb-2 ms-3">
        <button type="button" class="btn btn-success btn-sm" :disabled="exportLoading" @click="exportExcel">
          <i class="fa-regular fa-file-excel"></i> Excel
        </button>
        <button type="button" class="btn btn-danger btn-sm" :disabled="exportLoading" @click="exportPDF">
          <i class="fa-regular fa-file-pdf"></i> PDF
        </button>
        <button type="button" class="btn btn-secondary btn-sm" :disabled="exportLoading" @click="exportPrint">
          <i class="fa-solid fa-print"></i> Imprimir
        </button>
        <button type="button" class="btn btn-secondary btn-sm" :disabled="exportLoading" @click="exportCSV">
          <i class="fa-regular fa-file-lines"></i> CSV
        </button>
        <span v-if="exportLoading" class="small text-muted">Generando...</span>
      </div>
      <div>
        <div class="table-responsive">
          <DataTable
            :key="tableKey"
            class="table table-striped table-bordered display"
            :data="solicitudes"
            :columns="columns"
            :options="{
              serverSide: true,
              processing: true,
              ajax: ajaxDataTable,
              scrollX: true,
              autoWidth: true,
              dom: 'frtip',
              order: [[0, 'desc']],
              pageLength: 15,
              language: {
                search: 'Buscar en todas las columnas:',
                zeroRecords: 'No hay registros',
                info: 'Mostrando _START_ a _END_ de _TOTAL_ registros',
                infoFiltered: '(Filtrados de _MAX_ registros totales.)',
                processing: 'Cargando...',
                paginate: {
                  first: '<<',
                  previous: '<',
                  next: '>',
                  last: '>>',
                },
              },
            }"
          >
            <thead>
              <tr>
                <th>DNI</th>
                <th>Personal</th>
                <th>Institución</th>
                <th>Estado</th>
                <th>Fecha Inicio</th>
                <th>Fecha Fin</th>
                <th>Motivo</th>
                <th>Tipo de Lic.</th>
                <th>Cant. Dias</th>
                <th>Acciones</th>
              </tr>
            </thead>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="detallesModal" tabindex="-1" aria-labelledby="detallesModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="detallesModalLabel">Detalles de la Solicitud</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" v-if="selectedSolicitud">
          <div class="row mb-3">
            <div class="col-md-6">
              <p><strong>DNI:</strong> {{ selectedSolicitud.documento_empleado }}</p>
              <p><strong>Nombre:</strong> {{ selectedSolicitud.nombre_empleado }}</p>
              <p><strong>Institución:</strong> {{ selectedSolicitud.nombre_institucion }}</p>
              <p><strong>Profesional:</strong> {{ selectedSolicitud.nombre_profesional }}</p>
              <p><strong>Cargo:</strong> {{ selectedSolicitud.cargo }}</p>
              <p><strong>Estado:</strong> 
                <span :class="{
                  'badge badge-sm': true,
                  'bg-gradient-secondary': selectedSolicitud.nombre_estado === 'En proceso',
                  'bg-gradient-warning': selectedSolicitud.nombre_estado === 'Revision' || selectedSolicitud.nombre_estado === 'Revisión' || selectedSolicitud.nombre_estado === 'En revision' || selectedSolicitud.nombre_estado === 'En revisión' || selectedSolicitud.nombre_estado === 'En Revision' || selectedSolicitud.nombre_estado === 'En Revisión',
                  'bg-gradient-success': selectedSolicitud.nombre_estado === 'Aceptado',
                  'bg-gradient-danger': selectedSolicitud.nombre_estado === 'Rechazado'
                }">
                  {{ selectedSolicitud.nombre_estado }}
                </span>
              </p>
            </div>
            <div class="col-md-6">
              <p><strong>Fecha Inicio:</strong> {{ formatDate(selectedSolicitud.horario) }}</p>
              <p><strong>Fecha Fin:</strong> {{ formatDate(selectedSolicitud.horario, (selectedSolicitud.dias - 1)) }}</p>
              <p><strong>Motivo:</strong> {{ selectedSolicitud.nombre_motivo }}</p>
              <p><strong>Tipo de Licencia:</strong> {{ selectedSolicitud.tipo_licencia_id === 1 ? 'Corto Tratamiento' : 'Largo Tratamiento' }}</p>
              <p><strong>Días:</strong> {{ selectedSolicitud.dias }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p><strong>Observaciones:</strong></p>
              <p class="border p-3 bg-light">{{ selectedSolicitud.observaciones || 'Sin observaciones' }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>
